// Pure logic for the Bus Leaders Directory: statuses, sorting, filtering and
// summary numbers. No React/I/O so it is unit-tested.

export const LEADER_STATUSES = [
  { key: "on-journey", label: "On Journey", tone: "green" },
  { key: "available", label: "Available", tone: "blue" },
  { key: "upcoming", label: "Upcoming", tone: "amber" },
];

export const LEADER_SORTS = [
  { value: "name", label: "Name (A–Z)" },
  { value: "rating", label: "Highest rated" },
  { value: "books", label: "Most books" },
];

export const LEADER_PAGE_SIZE = 9;

export function findStatus(key) {
  return LEADER_STATUSES.find((status) => status.key === key);
}

const SORTERS = {
  name: (a, b) => a.name.localeCompare(b.name),
  rating: (a, b) => b.rating - a.rating || a.name.localeCompare(b.name),
  books: (a, b) => b.books - a.books || a.name.localeCompare(b.name),
};

// filters: { search, state, status, sort } — every part optional.
export function filterLeaders(leaders, { search = "", state = "", status = "", sort = "name" } = {}) {
  const needle = search.trim().toLowerCase();
  return leaders
    .filter((entry) => {
      if (state && entry.state !== state) return false;
      if (status && entry.status !== status) return false;
      if (!needle) return true;
      return [entry.name, entry.team, entry.base, entry.state].some((field) => field.toLowerCase().includes(needle));
    })
    .sort(SORTERS[sort] || SORTERS.name);
}

// Counts per status, ignoring the status filter itself so the chips show what
// each would return for the current search/state.
export function countByStatus(leaders) {
  const counts = { all: leaders.length };
  LEADER_STATUSES.forEach((status) => {
    counts[status.key] = leaders.filter((entry) => entry.status === status.key).length;
  });
  return counts;
}

export function summarize(leaders) {
  const total = leaders.length;
  const rated = leaders.filter((entry) => typeof entry.rating === "number");
  const avg = rated.length ? rated.reduce((sum, entry) => sum + entry.rating, 0) / rated.length : 0;
  return {
    total,
    onJourney: leaders.filter((entry) => entry.status === "on-journey").length,
    available: leaders.filter((entry) => entry.status === "available").length,
    avgRating: Math.round(avg * 10) / 10,
  };
}

export function stateOptionsOf(leaders) {
  return [...new Set(leaders.map((entry) => entry.state))].sort();
}
